<template>
  <div v-show="this.data.length !== 0" style="width: 100%;">
    <h3>{{tableType}}</h3>
    <el-table
        stripe
        border
        max-height="400"
        size="mini"
        style="width: 100%"
        :data="data.slice((pageinfo.currentPage-1)*pageinfo.pageSize,pageinfo.currentPage*pageinfo.pageSize)">
      <el-table-column prop="spot" label="spot" sortable show-overflow-tooltip fixed="left" min-width="50"></el-table-column>
      <div v-for="(item,index) in columns" :key="index">
        <el-table-column :prop="item" :label="item" sortable show-overflow-tooltip></el-table-column>
      </div>
    </el-table>
    <el-pagination align='center' @size-change="handleSizeChange" @current-change="handleCurrentChange"
                   :current-page="pageinfo.currentPage"
                   :page-sizes="[10,20,50,100]"
                   :page-size="pageinfo.pageSize"
                   layout="total, sizes, prev, pager, next, jumper"
                   :total="data.length">
    </el-pagination>
    <div :id="vue_div" style="width: 800px; min-width: 800px; height: 800px; margin: auto"/>
  </div>


</template>

<script>
import * as echarts from 'echarts';
// import sankeyData from '@/assets/testData/sankeyTest.json'
import sankeyData from '@/assets/testData/CID44971_cellchat.json'

export default {
  name: "SankeyCard",
  data(){
    return{
      formData: {
        datasetID: '',
        Array: '',
      },
      data: [],
      columns: [],
      list_data: {},
      type: '',
      pageinfo: {
        currentPage: 1,
        pageSize: 10
      },
      vue_div: '',
    }
  },
  props:{
    tableType: String,
    datasetID: Number,
    Array: String,
  },
  mounted() {
    this.vue_div = this.tableType + '_sankey'
    this.formData.datasetID = this.datasetID
    this.formData.Array = this.Array
    this.getTableData()
  },
  methods:{
    getTableData() {
      let _this = this
      console.log(_this.formData.datasetID + '/' + _this.formData.Array)
      _this.$axios.get(
          'http://' + _this.$global.serverIP + ':' + _this.$global.serverHost + '/celltype/'+ _this.tableType +'/' + _this.formData.datasetID + '/' + _this.formData.Array)
          .then(function (response) {
            // console.log(_this.tableType + ':')
            // console.log(response)
            _this.data = eval('(' + response.data.data + ')')
            console.log(_this.data)
            _this.processData()
            _this.initSankey()
          })
    },
    processData() {
      let _this = this
      let temp = _this.data[0]
      // console.log(temp)
      let keyData = Object.keys(temp)
      _this.columns = []
      for (let i = 0; i < keyData.length; i++) {
        if (keyData[i] !== 'spot' && keyData[i] !== 'x' && keyData[i] !== 'y') {
          _this.columns.push(keyData[i])
        }
      }
      console.log(_this.columns)
    },
    initSankey(){
      const chartDom = document.getElementById(this.vue_div);
      const myChart = echarts.init(chartDom);
      let option;
      myChart.showLoading();
      myChart.hideLoading();
      myChart.setOption(
          (option = {
            title: {
              text: 'Sankey Diagram'
            },
            tooltip: {
              trigger: 'item',
              triggerOn: 'mousemove',
            },
            series: [
              {
                type: 'sankey',
                data: sankeyData.nodes,
                links: sankeyData.links,
                emphasis: {
                  focus: 'adjacency'
                },
                levels: [
                  {
                    depth: 0,
                    itemStyle: {
                      color: '#fbb4ae'
                    },
                    lineStyle: {
                      color: 'source',
                      opacity: 0.6
                    }
                  },
                  {
                    depth: 1,
                    itemStyle: {
                      color: '#b3cde3'
                    },
                    lineStyle: {
                      color: 'source',
                      opacity: 0.6
                    }
                  },
                  {
                    depth: 2,
                    itemStyle: {
                      color: '#ccebc5'
                    },
                    lineStyle: {
                      color: 'source',
                      opacity: 0.6
                    }
                  },
                  {
                    depth: 3,
                    itemStyle: {
                      color: '#decbe4'
                    },
                    lineStyle: {
                      color: 'source',
                      opacity: 0.6
                    }
                  },
                  {
                    depth: 4,
                    itemStyle: {
                      color: '#9999FF'
                    },
                    lineStyle: {
                      color: 'source',
                      opacity: 0.6
                    }
                  }
                ],
                lineStyle: {
                  curveness: 0.5
                }
              }
            ]
          })
      );

      option && myChart.setOption(option);

    },
    handleSizeChange(val) {
      this.pageinfo.currentPage = 1;
      this.pageinfo.pageSize = val;
    },
    //当前页改变时触发 跳转其他页
    handleCurrentChange(val) {
      this.pageinfo.currentPage = val;
    },
  }
}
</script>

<style scoped>

</style>
